import { ChatRoomType, Profile } from '@dinosband/bv-main-schema/dist/types'
import { ChatRoomQueryOption } from '@dinosband/bv-messenger-schema'

export function chatRoomIdsInProfile (profile: Profile) {
  const chatRooms = profile.chatRooms.map((i) => i.chatRoomId)
  const channelRooms = profile.channels.flatMap((i) => i.channel.channelRoomId ?? [])
  return chatRooms.concat(channelRooms)
}

/*
export function getMesgFilter (chatRoom: ChatRoom) {
  if (chatRoom.type != ChatRoomType.JOB_OFFER) {
    return
  }
  const profileChannel = mainStore.currentChannelAndProfile?.profile_channels[0]
  const s = profileChannel?.mesgFilter
  if (!s) {
    return
  }
  const filter = JSON.parse(s) as MesgFilter
  filter.matchKeywords = filter.matchKeywords.filter((i) => i.length)
  if (filter.matchKeywords.length == 0 && filter.locations.length == 0) {
    return
  }
  return filter
} */

const JobOfferChatRoomOption: ChatRoomQueryOption = {
  filterOwnMessages: true,
  excludeDeleted: true,
}

const HelpDeskChatRoomOption: ChatRoomQueryOption = {
  excludeDeleted: false,
  onlyOwnMessages: true,
  includeByAdmin: true,
}

export function chatRoomQueryOption (type?: ChatRoomType, isAdmin?: boolean): ChatRoomQueryOption | undefined {
  if (type === ChatRoomType.JOB_OFFER || type === ChatRoomType.INFO) {
    return JobOfferChatRoomOption
  }
  // HELPDESK를 1:1 챗룸으로 변경하여 filter가 필요없음
  // if (type === ChatRoomType.HELPDESK && !isAdmin) {
  //   return HelpDeskChatRoomOption
  // }
}